theme.getFullSizeName=function(e){switch(e){case"XXS":return"2X-Small";case"XS":return"X-Small";case"S":return"Small";case"M":return"Medium";case"L":return"Large";case"XL":return"X-Large";case"XXL":return"2X-Large";default:return e}};

const productRecommendations = (color = false) => {
  const recommendations = document.querySelector('.product-recommendations');
  const colorInput = document.querySelector('variant-radios input[name="Color"]');
  const productColor = color ? color : window.currentVariant.option1;
  const recommendationsList = document.querySelector('.product-recommendations__list');

  if(!recommendationsList) return;
  let fetchUrl = `/search?q=title:${productColor}&type=product&view=none`;
  const dataType = recommendationsList.getAttribute('data-type');
  
  if(dataType === 'metafield') {
    fetchUrl = recommendationsList.getAttribute('data-url') + '?view=none';
  }
  
  if(!recommendationsList) return;




  // console.log(dataType);
  // console.log(window.currentVariant.option1);
  // console.log('theme.getRecommendations',productColor);
  // console.log(fetchUrl);
  
  recommendationsList.innerHTML = '';
  if(!window.productJSON || !productColor) return;
  
  fetch(fetchUrl)
  .then(function(response) {
    return response.text();
  })
  .then(function(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const products = doc.querySelectorAll('.product-grid .grid__item');
    recommendationsList.innerHTML = '';
    products.forEach((product) => {
      let productTitle = product.querySelector('.card--product').getAttribute('data-id');
      if(productTitle != window.currentVariant.productId) {
        product.classList.add('overflow--scroll-x__item');
        recommendationsList.appendChild(product);
        // console.log(product);
      }
    });
  })
  .catch(function(err) {
    console.warn('something went wrong.',err);
  });
};

theme.allIngredintsButton = function() {
  const allIngredientsButton = document.getElementById('full-ingredient-list__button');
  if(!allIngredientsButton) return; 
  allIngredientsButton.addEventListener('click',event => {
    event.preventDefault();
    const isOpen = event.target.getAttribute('aria-expanded') === 'true';
    const allIngredients = document.getElementById(event.target.getAttribute('aria-controls'));
    if(!isOpen) {
      allIngredients.removeAttribute('hidden');
    } else {
      allIngredients.setAttribute('hidden',true);
    }
    allIngredientsButton.setAttribute('aria-expanded',!isOpen);
  });
}

var Shopify=Shopify||{};Shopify.money_format="${{amount}}",Shopify.formatMoney=function(a,o){"string"==typeof a&&(a=a.replace(".",""));var e="",t=/\{\{\s*(\w+)\s*\}\}/,o=o||this.money_format;function r(a,o){return void 0===a?o:a}function n(a,o,e,t){if(o=r(o,2),e=r(e,","),t=r(t,"."),isNaN(a)||null==a)return 0;a=(a=(a/100).toFixed(o)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?t+a[1]:"")}switch(o.match(t)[1]){case"amount":e=n(a,2);break;case"amount_no_decimals":e=n(a,0);break;case"amount_with_comma_separator":e=n(a,2,".",",");break;case"amount_no_decimals_with_comma_separator":e=n(a,0,".",",")}return o.replace(t,e)};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    
    this.addEventListener("change",(event) => {
      _this.onVariantChange(event);
    });
    this.useSelects = document.querySelector(".select__select--color");
    this.useRadios = document.querySelector("variant-radios");

    
    this.selects = document.querySelectorAll(".select__select");
    this.selects.forEach(function (select) {
      select.addEventListener("change", _this.onSelectChange);
    });
    
    theme.finishedProductLoading();
    theme.allIngredintsButton();
    
    this.addButtons = document.querySelectorAll('.product-form__submit');

    productRecommendations();


    
    // theme.loadScript('//js.narvar.com/frankiesbikinis/en/US/narvar.js')
    // .then(() => {
    //   narvar('eddCalculator', {});
    // })
    // .catch(() => {
    //   console.error('Narvar loading failed! Handle this error');
    // });

	this.selectedSize = false;

	this.onInit();

	const moreColorsButton = document.querySelector('#colors--secondary__button');
    const moreColors = this.querySelectorAll('.variant-radio[data-core-color="false"]');
    if(moreColorsButton) {
        if(moreColors.length > 0) {
          moreColorsButton.classList.remove('hidden');
        }

        moreColorsButton.addEventListener('click',(e) => {
          e.preventDefault();
          moreColorsButton.classList.add('hidden');
          moreColors.forEach((color) => {
            color.classList.add('visible');
          });
        });
    }

    this.giftCard = document.querySelector('body').classList.contains('template-product-gift-card');

  }
  
  hasSizes() {
    const sizeInputEl = document.querySelector('.product-form__input[data-option="Size"]');
    return (typeof(sizeInputEl) != 'undefined' && sizeInputEl != null) ? sizeInputEl : false;
  }

  sizeChecked() {
    const sizeInput =
      this.querySelector('.product-form__input[data-option="Size"] input:checked') ||
      document.querySelector('.product__info-wrapper .product-form__input[data-option="Size"] input:checked') ||
      document.querySelector('.product-form__input[data-option="Size"] input:checked');
    return sizeInput || false;
  }

  colorChecked() {
    const colorInput =
      this.querySelector('.product-form__input[data-option="Color"] input:checked') ||
      document.querySelector('.product__info-wrapper .product-form__input[data-option="Color"] input:checked') ||
      document.querySelector('.product-form__input[data-option="Color"] input:checked');
    return colorInput || false;
  }

  setAvailabilities() {
    const colorChecked = this.colorChecked();
    if(!colorChecked) return;

    const colorCheckedValue = colorChecked.value;

    window.productJSON.variants.forEach(variant => {
      if(variant.options[0] === colorCheckedValue) {
        const myInput = document.querySelector(`.product-form__input[data-option="Size"] input[value="${variant.options[1]}"]`);
        const myInputSticky = document.querySelector(`.product__swatches-dropdown[data-option="Size"] input[value="${variant.options[1]}"]`);
     
        if(myInput) {
          /* Check variant preOrder status */
          const variantLimit = variant.preOrderLimit;
          const variantQty = Math.abs(variant.inventory_quantity);
          const variantAvailable =  variantQty < variantLimit;
          
          if(variant.preOrder) {
            if(variantAvailable) {
              myInput.classList.remove('soldout');
              if(myInputSticky && myInputSticky.classList.contains("soldout")){
                myInputSticky.classList.remove('soldout');
              }
            } else {
              myInput.classList.add('soldout');
              if(myInputSticky) myInputSticky.classList.add('soldout');
            }
          } else if(variant.available) {
            myInput.classList.remove('soldout');
            if(myInputSticky && myInputSticky.classList.contains("soldout")){
              myInputSticky.classList.remove('soldout');
            }
          } else {
            myInput.classList.add('soldout');
            if(myInputSticky) myInputSticky.classList.add('soldout');
          }
        }
      }
    });
  }

  isSecondaryColor() {
    return;
    const selectedColor = document.querySelector('.product-form__input[data-option="Color"] input:checked');
    if(!selectedColor) return;
    const selectedColorHidden = selectedColor.closest('.variant-radio').getAttribute('data-core-color');

    if(selectedColor && selectedColorHidden == 'false') {
      selectedColor.closest('.variant-radios--wrapper').querySelectorAll('.variant-radio').forEach((item) => {
        item.classList.add('visible');
      });
      document.querySelector('#colors--secondary__button').style.display="none";
    }
    
  }

  onInit() {
    const sizeInput = document.querySelector('.product-form__input[data-option="Size"]');
    if(!sizeInput) {
      this.onVariantChange();
      return;
    };
	this.setAvailabilities();
    if(!this.sizeChecked()) {
      this.setDefaults();
    } else {
      this.onVariantChange();
    }
    this.fourSixtyListener();
//     this.isSecondaryColor();
    
  }

  setDefaults() {
    if(document.querySelector('body').classList.contains('template-product-gift-card')) return;
    const sizeCurrentValue = document.querySelector('.product-form__input[data-option="Size"] .current-value');
    if (sizeCurrentValue) {
      sizeCurrentValue.innerHTML = `<span class="no-size-selected">${window.variantStrings.selectSize}</span>`;
    }

    this.addButtons.forEach(function (addButton) {
      addButton.textContent = window.variantStrings.selectSize;
      addButton.setAttribute("disabled", true);
      addButton.classList.remove('loading');
    })
    
  }
  
  fourSixtyListener() {
    const foursixty = document.getElementById('foursixty');
    const productRecs = document.getElementById('product-recommendations');
    if(foursixty && productRecs && foursixty.style.display === 'none' ) {
      productRecs.style.paddingTop = '50px';
    }
    return;
    let fs = document.getElementById('foursixty'),
    fsOptions = {
      childList: true
    },
    fsObserver = new MutationObserver(fsCallback);

    function fsCallback(mutations) {
      for (let mutation of mutations) {
        if (mutation.type === 'childList') {
          console.log('Mutation Detected: A child node has been added or removed.');
        }
      }
    }
    fsObserver.observe(fs, fsOptions);
  }

  onSelectChange(e) {

    const idx = e.target.dataset.optionIndex;
    const currentValue = e.target.value;
    document.querySelectorAll(".select__select").forEach(function (select) {
      if (e.target != select) {
        window.productJSON.variants.forEach(function (variant) {
          if (variant.options[idx] == currentValue) {
            variant.options.forEach(function (option, o) {
              if (o == idx) return true;
              if (variant.available) {
                
              } else {
                
              }
            });
          }
        });
      }
    });
  }

  finalSale() {
    const finalSale = document.querySelector(".final-sale__wrapper");
    if (!finalSale || !this.currentVariant) return;
    const productForm = document.querySelector("product-form form");
    const productSection = document.querySelector(".product-section");
    
    const listPrice = this.currentVariant.compare_at_price;
    const salePrice = this.currentVariant.price;
    const discount = listPrice ? ((listPrice - salePrice)/listPrice) * 100 : 0;
	const isFinalSale = discount >= 30 ? true : false;
    
    if (isFinalSale && productForm) {
      productForm.appendChild(finalSale);
    } else if (productSection) {
      productSection.appendChild(finalSale);
    }
  }

   preOrderBIS() {
    messages.classList.add("hidden");
     if (email === "") {
       messages.textContent = "Please enter a valid email";
       messages.classList.remove("hidden");
       return false;
     }
    const variantId = this.currentVariant.id || false;
    const productId = this.currentVariant.productId || false;
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2024-06-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${ variantId }`
              }
            }
          }
        }
      })
    };
    
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${ window.klaviyoAccountId }`, options)
    // .then(response => response.json())
    .then(response => {
       if (response.status == 202) {
         messages.textContent = "You're in! We'll let you know when it's back.";
       } 
       else {
       }
       messages.classList.remove("hidden");
    })
    .catch(err => console.error(err));
   }

  preOrderAvailable() {
    const variantLimit = window.currentVariant.preOrderLimit;
    if(!variantLimit) return false;
    
    const variantQty = Math.abs(this.currentVariant.inventory_quantity);
    return variantQty < variantLimit;
  }

  preOrder() {
    const preOrderInputs = document.getElementById("preorder-inputs");
    const productForm = document.querySelector("product-form form");
    const productSection = document.querySelector(".product-section");
    const preOrderInput = document.getElementById('preorder-input');
    const narvarInput = document.getElementById('narvar-input');
    const preOrderText = document.querySelector('.pre-order__text');
       
    if (this.currentVariant.preOrder && this.preOrderAvailable()) {
      preOrderInput.value = this.currentVariant.preOrder;
      narvarInput.value = this.currentVariant.preOrder;
      productForm.appendChild(preOrderInputs);
      preOrderText.textContent = this.currentVariant.preOrder;
      preOrderText.classList.remove('hidden');
    } else {
      preOrderInput.value = '';
      narvarInput.value = '';
      productSection.appendChild(preOrderInputs);
      preOrderText.textContent = '';
      preOrderText.classList.add('hidden');
    }
//     document.querySelector('.product-form__submit').classList.remove('loading');
    
  }

  updateBackgroundColor() {
    this.currentVariant = this.currentVariant ? this.currentVariant : window.currentVariant;
    document.querySelector('.product-section').style.backgroundColor = this.currentVariant.backgroundColor;
  }

  updateStickyBar() {
    let productBarForm = document.querySelector(".product-bar__form");
    if(productBarForm){
      let variantIdInput = productBarForm.querySelector(`input[name="id"]`);
      if(variantIdInput){
        variantIdInput.value = this.currentVariant.id;
      }
    }

    let option2 = this.currentVariant.option2;
    
    if (option2) {
      const captionEl = document.querySelector(".product__collection-size .product__swatches-button-sticky .caption-neue");
      const selectableInput = document.querySelector(`.product__collection-size input[value="${option2}"]`);
    
      if (captionEl) {
        captionEl.innerHTML = `
          <span class="product-form__input-active-size-bubble">${option2}</span>${theme.getFullSizeName(option2)}
        `;
      }
    
      if (selectableInput) {
        selectableInput.checked = true; // more semantic than setAttribute
      }
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    
    if(!this.sizeChecked() && this.colorChecked() && !this.giftCard) {
      const colorChecked = this.colorChecked();
      const currentColorUrl = colorChecked.getAttribute('data-url');
      this.updateContent(currentColorUrl);
      this.updateURL(currentColorUrl);
      return;
    }

    if(this.sizeChecked()) {
      this.selectedSize = this.sizeChecked().value;

      const embroidery = document.querySelector('[data-open-embroidery]');
      if (embroidery && embroidery.disabled == true) {
        embroidery.disabled = false;
      }
    }
    
    if (!this.currentVariant) {
      this.currentVariant = window.currentVariant;
    } else {
      window.currentVariant = this.currentVariant;
    }

    this.updateMedia(event);
    
    if(event && event.target.name == 'Color') {
      this.updateContent(event.target.getAttribute('data-url'));
    }

    // Sync form + ATC before URL so a history error never blocks add-to-cart
    this.updateVariantInput();
    this.updateCurrentOptions();
    this.klaviyoBIS();
    this.updateInventory();
    this.updateAddButton();
    this.preOrder();
    this.updatePrice();
    this.updateBnpl();
//     this.updateAfterpay();
    this.finalSale();
    window.currentVariant = this.currentVariant;
    this.setAvailabilities();
    this.updateURL();
  
//     this.updateKlarna();
  }

  updateKlarna() {
    document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", this.currentVariant.price);
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
  }

  updateBnpl() {
    if(document.querySelector('body').classList.contains('template-product-gift-card')) return;
    if (!window.currentVariant) return;
    
    const priceEl = document.querySelector('.bnpl-dynamic-price');
    if (!priceEl) return;
    const smallPrice = window.currentVariant.price / 4
    priceEl.innerHTML = Shopify.formatMoney(smallPrice).replace('.00','');
  }

  klaviyoBIS() {
    if(document.querySelector('body').classList.contains('template-product-gift-card')) return;
    if (!theme.klaviyoBIS?.enabled) return;
    if(!this.currentVariant) return;
    
    const bisWrappers = document.querySelectorAll(".klaviyo-bis-wrapper");
    let addButtons = document.querySelectorAll('.product-form__submit');
    
    
    if(this.currentVariant.preOrder) {
      if(this.preOrderAvailable()) {
        addButtons.forEach(addButton => addButton.classList.remove("hidden"));
        bisWrappers.forEach(bisWrapper => bisWrapper.classList.add("hidden"));
      } else {
        bisWrappers.forEach(bisWrapper => bisWrapper.classList.remove("hidden"));
        addButtons.forEach(addButton => addButton.classList.add("hidden"));

      }
      return;
    } 
    
    this.currentVariant.available
      ? bisWrappers.forEach(bisWrapper => bisWrapper.classList.add("hidden"))
      : bisWrappers.forEach(bisWrapper => bisWrapper.classList.remove("hidden"));

    if (theme.klaviyoBIS.hide_add_button) {
      
      this.currentVariant.available
        ? addButtons.forEach(addButton => addButton.classList.remove("hidden"))
        : addButtons.forEach(addButton => addButton.classList.add("hidden"));
    }
  }

  updateCurrentOptions() {
    if (this.useSelects) return;
    let _this = this;
    this.options.forEach(function (option, o) {
      const optionIndexValue = document.querySelector(`variant-radios .product-form__input[data-option-index="${o}"] .current-value`);
      if(optionIndexValue) {
        optionIndexValue.textContent = theme.getFullSizeName(option);
      }
    });
  }

  updateOptions() {
    if (this.useRadios) return;
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }
	
  updateAddButton() {
    if(this.currentVariant.preOrder && this.preOrderAvailable()) {
      this.toggleAddButton(false,theme.preorderText,false);
    } else if(this.currentVariant.available) {
      this.toggleAddButton(false, window.variantStrings.addToCart,true);
    } else if (!theme.klaviyoBIS?.enabled) {
      // FINAL SALE (BIS disabled): keep ATC visible and show Sold out
      document.querySelectorAll('.product-form__submit').forEach((addButton) => {
        addButton.classList.remove('hidden');
      });
      this.toggleAddButton(true, window.variantStrings.soldOut, true);
    }
    document.querySelectorAll('.product-form__submit').forEach(addButton => addButton.classList.remove('loading'));
    
    this.updateStickyBar();

  }

  updateAfterpay() {
    const afterpayAmount = document.querySelector('.product__info-container .afterpay-amount');
    const afterpayPrice = this.currentVariant.price / 4;
    afterpayAmount.innerHTML = Shopify.formatMoney(afterpayPrice).replace('.00','');
  }

  updatePrice() {
    /* This is only for gift cards */
    if(productJSON.tags.indexOf("GIFT CARD") == -1) return;
    const priceEl = document.querySelector('.product__info-wrapper .price__regular .price-item--regular');
    
    if(!priceEl) return;
    priceEl.innerHTML = Shopify.formatMoney(window.currentVariant.price).replace('.00','');
  }
  
  

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getSections() {
    return [
      {
        id: "product-recommendations",
      },
      {
        id: "foursixty",
      }
    ];
  }

 

  startLoading() {
    document
      .querySelector(".product .loading-overlay")
      .classList.remove("hidden");
  }

  finishLoading() {
    document.querySelector(".product .loading-overlay").classList.add("hidden");
    this.setAvailabilities();
    theme.videoOnScroll();
    theme.scrollAnimations();
    theme.allIngredintsButton();
    
    
    if(this.selectedSize) {
      const selectedValue = this.selectedSize;
      const selectedSizeEl = document.querySelector(`input[name="Size"][value="${selectedValue}"]`);
      if(selectedSizeEl) {
        selectedSizeEl.checked = true;
      }else {
        this.setDefaults();
      }

      const selectedSizeElSticky = document.querySelector(`.product__swatches-button-sticky .no-size-selected`);
      if(selectedSizeElSticky && selectedValue){
        selectedSizeElSticky.innerHTML = selectedValue;
      }
      
    }
    
  }
      
      
  updateJson(url) {
    fetch(url+'?view=metafields')
    .then(function(response) {
      return response.text();
    })
    .then(function(data) { 
      const newData = JSON.parse(data);
      newData.variants.forEach((newVariant) => {
        window.productJSON.variants.forEach((variant) => {
      	  if(newVariant.id != variant.id) return;
      	  variant.finalSale = newVariant.finalSale;
          variant.inventory = newVariant.inventory;
          variant.preOrder = newVariant.preOrder;
          variant.preOrderLimit = newVariant.preOrderLimit;
        });
      });

      if (newData.sweetShop) {
        document.documentElement.style.setProperty('--ss-background', newData.sweetShop.background);
        document.documentElement.style.setProperty('--ss-text', newData.sweetShop.color);
      }
    });
  }
      

  updateContent(url = false) {
    const _this = this;

    const currentUrl = window.location.href;
    const newUrl = url ? url : this.currentVariant.productUrl;

    if(!newUrl) return;
    if (currentUrl.indexOf(newUrl) != -1) return false;

    _this.startLoading();
    const elementsToUpdate = [
      ".product__media-wrapper",
      ".product-media-modal__content",
      ".product__description",
      ".product__title",
      "#background-color",
      ".product__price",
      ".promo-text__wrapper",
      ".final-sale__wrapper",
      ".product__accordion--description .accordion__content",
      ".product__accordion--fabric .accordion__content",
      ".product__accordion--size-fit .accordion__content",
      ".product-recommendations",
      "#shopify-section-promo-bar",
    ];
    
    if(this.hasSizes()) {
      elementsToUpdate.push(".product-form__input[data-option='Size'] .variant-radios--wrapper");
    }
    
    fetch(newUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        _this.querySelectorAll("input[type='radio']:checked").forEach(function (element) {
          if(element.getAttribute("name") && (element.getAttribute("name") === "Color" || element.getAttribute("name") === "color")){
            let dataColorHandle = element.dataset.colorHandle;
            let dataColorValue = element.value;
            let productBarTitle = document.querySelector(".product-bar__title .sh1");
            if(productBarTitle){
              let nameWithoutOption = element.dataset.title?.split('-')?.[0];
              productBarTitle.innerHTML = nameWithoutOption;
            }
            if(dataColorHandle && dataColorValue){
              let productCollectionColors = document.querySelector(".product__collection-colors");
              if(productCollectionColors){
                let productSwatchColor = productCollectionColors.querySelector(".product__swatch-color");
                if(productSwatchColor){
                  productSwatchColor.setAttribute("data-value", dataColorHandle);
                  let captionNeue = productCollectionColors.querySelector(".caption-neue");
                  if(captionNeue){
                    captionNeue.innerHTML = dataColorValue;
                  }
                  let swatchImageStyle = element.nextElementSibling.style.backgroundImage;
                  if (swatchImageStyle) {
                    productSwatchColor.style.backgroundImage = swatchImageStyle;
                  }
                }
                let activeSwatch = productCollectionColors.querySelector(".product__swatch.active");
                if(activeSwatch){
                  activeSwatch.classList.remove("active");
                  
                }
                let currentEligibleValueEl = document.querySelector(`.product__color-swatches-dropdown [data-value="${dataColorHandle}"]`);
                if(currentEligibleValueEl){
                  currentEligibleValueEl.closest(".product__swatch").classList.add("active");
                }

                document.querySelectorAll('.product__color-swatches-dropdown').forEach((dropdown) => {
                  const valueEl = dropdown.querySelector(`[data-value="${dataColorHandle}"]`);
                  if (valueEl) {
                    valueEl.checked = true;
                  }
                });
              }

            }
          }
        })
        
        elementsToUpdate.forEach((selector) => {
          const targetEl = document.querySelector(selector);
          const sourceEl = doc ? doc.querySelector(selector) : null;

          // Skip if either target or source is missing
          if (!targetEl || !sourceEl) return;

          // Skip if source element doesn't have innerHTML
          if (typeof sourceEl.innerHTML !== "string") return;

          targetEl.innerHTML = sourceEl.innerHTML;
        });


        if (typeof window.productGlide == "function") {
          window.productGlide();
        }

        _this.updateJson(newUrl);
        // _this.updateURL(newUrl);
        // _this.updateRelatedProducts(newUrl);

        _this.checkVariantsAndProps();

        _this.finishLoading();
        _this.finalSale();
        productRecommendations();
      })
      .catch(function (err) {
        // There was an error
        console.log(err);
        _this.finishLoading();

      });
  }

  checkVariantsAndProps() {
    setTimeout(function(){
      document.querySelector("variant-radios")?.dispatchEvent(new Event("change",{bubbles:true}));

      const sizeChecked = document.querySelector(".product__info-wrapper variant-radios [data-option='Size'] input:checked");

      if (!sizeChecked) {
        const submitBtn = document.querySelector(".product__info-wrapper product-form .product-form__buttons [type='submit']");
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = "select a size";
        }

        document.querySelector(".product__info-wrapper .low-inventory__message")?.style && 
          (document.querySelector(".product__info-wrapper .low-inventory__message").style.display = "none");

        document.querySelector(".product__info-wrapper .pre-order__text")?.classList?.add("hidden");

        const stickyCaption = document.querySelector(".product-bar__container .product__collection-size .product__swatches-button-sticky .caption-neue");
        if (stickyCaption) stickyCaption.innerHTML = `<span class="no-size-selected">select a size</span>`;

        const checkedStickySize = document.querySelector(".product-bar__container .product__collection-size .product-form__input input:checked");
        if (checkedStickySize) checkedStickySize.checked = false;

        const barSubmitBtn = document.querySelector(".product-bar__container .product-form .product-form__buttons [type='submit']");
        if (barSubmitBtn) {
          barSubmitBtn.textContent = "select a size";
          barSubmitBtn.disabled = true;
        }
      }
    }, 1000)
  }


  updateInventory() {
    const lowQuantityMessage = document.querySelector(
      ".low-inventory__message"
    );
    if (!lowQuantityMessage) return;
    if (this.currentVariant.inventory <= 0) {
      lowQuantityMessage.style.display = "none";
      return;
    }
    const threshold = parseFloat(
      lowQuantityMessage.getAttribute("data-threshold")
    );
    const blockDisplay =
      this.currentVariant.inventory < threshold ? "block" : "none";
    lowQuantityMessage.style.display = blockDisplay;
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    if (!this.currentVariant.featured_image?.position) return;
    if (!window.glide || typeof window.glide.go !== 'function') return;

    const myImagePosition = this.currentVariant.featured_image.position - 1;
    window.glide.go(`=${myImagePosition}`);
  }

  updateURL(url = false) {
    if (!this.currentVariant && !url) return;

    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    params.delete('variant');

    // Shopify Markets root, e.g. "/" or "/en-us/" or "/en-ie/"
    const routesRoot = window.Shopify?.routes?.root || '/';

    const toPathname = (value) => {
      if (!value) return currentUrl.pathname;
      try {
        if (/^https?:\/\//i.test(value)) {
          return new URL(value).pathname;
        }
      } catch (e) {
        // Only guards malformed absolute URLs while parsing; does not swallow variant errors
      }
      const pathOnly = String(value).split('?')[0];
      return pathOnly[0] === '/' ? pathOnly : `/${pathOnly}`;
    };

    const applyMarketRoot = (pathname) => {
      let path = pathname || '/';
      if (!path.startsWith('/')) path = `/${path}`;
      if (!routesRoot || routesRoot === '/') return path;

      const root = routesRoot.endsWith('/') ? routesRoot.slice(0, -1) : routesRoot;
      if (path === root || path.startsWith(`${root}/`)) return path;

      // Strip a different locale prefix before applying the current market root
      const withoutLocale = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
      return `${root}${withoutLocale.startsWith('/') ? withoutLocale : `/${withoutLocale}`}`;
    };

    const productHandleFromPath = (pathname) => {
      const match = pathname.match(/\/products\/([^/?#]+)/i);
      return match ? match[1] : null;
    };

    let pathname;
    if (url) {
      pathname = applyMarketRoot(toPathname(url));
    } else if (this.currentVariant) {
      const variantPath = toPathname(this.currentVariant.productUrl || currentUrl.pathname);
      const currentHandle = productHandleFromPath(currentUrl.pathname);
      const variantHandle = productHandleFromPath(variantPath);

      // Same product: keep the exact current market/locale path, only update ?variant=
      if (currentHandle && variantHandle && currentHandle === variantHandle) {
        pathname = currentUrl.pathname;
      } else {
        pathname = applyMarketRoot(variantPath);
      }
    } else {
      return;
    }

    const newUrl = new URL(pathname, window.location.origin);
    if (url) {
      // Color navigation: only keep a variant param if the provided URL already has one
      try {
        const providedVariant = new URL(url, window.location.origin).searchParams.get('variant');
        if (providedVariant) params.set('variant', providedVariant);
      } catch (e) {
        // Ignore malformed provided URLs when reading optional variant param
      }
    } else if (this.currentVariant?.id) {
      params.set('variant', String(this.currentVariant.id));
    }
    newUrl.search = params.toString();

    try {
      // Always use same-origin path so preview/dev/shopifypreview don't throw SecurityError
      window.history.replaceState({}, "", `${newUrl.pathname}${newUrl.search}${newUrl.hash}`);
    } catch (e) {
      console.warn('updateURL failed', e);
    }
  }

  updateVariantInput() {
    if (!this.currentVariant?.id) return;

    const selectors = [
      `#product-form-${this.dataset.section}`,
      '#product-form-installment',
      'form[id^="product-form-main-product-"]',
    ];

    if (this.dataset.productId) {
      selectors.push(`#product-form-main-product-${this.dataset.productId}`);
    }

    const productForms = document.querySelectorAll(selectors.join(', '));
    const updated = new Set();

    productForms.forEach((productForm) => {
      if (updated.has(productForm)) return;
      updated.add(productForm);

      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateRecommendations() {
    const url = `${this.currentVariant.productUrl}?section_id=product-recommendations`;
    const elements = ['.product-recommendations'];
    theme.fetchReplaceHTML(url, elements);
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    let addButtons = document.querySelectorAll('[name="add"]');
    
    if(!addButtons) return;

    if (disable) {
      addButtons.forEach(addButton => addButton.setAttribute("disabled", true));
      
    } else {
      addButtons.forEach(addButton => addButton.removeAttribute("disabled"));
      addButtons.forEach(addButton => {
        let buttonText = window.variantStrings.addToCart;
        // Add price for sticky buttons
        if (addButton.classList.contains('product-form__submit-sticky') && this.currentVariant) {
          const price = Shopify.formatMoney(this.currentVariant.price).replace('.00','');
          buttonText = `${buttonText} - ${price}`;
        }
        addButton.textContent = buttonText;
      });
    }

    if (text) {
      addButtons.forEach(addButton => {
        let buttonText = text;
        // Add price for sticky buttons only when the variant is purchasable
        if (!disable && addButton.classList.contains('product-form__submit-sticky') && this.currentVariant) {
          const price = Shopify.formatMoney(this.currentVariant.price).replace('.00','');
          buttonText = `${buttonText} - ${price}`;
        }
        addButton.textContent = buttonText;
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    
    let addButtons = document.querySelectorAll('[name="add"]');
    if(!addButtons) return;

    addButtons.forEach(addButton => addButton.textContent = window.variantStrings.unavailable);

    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || window.productJSON.variants;
    
    return this.variantData;
  }
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.currentVariant = window.currentVariant;
  }

  updateOptions() {
    const checkedRadios = document.querySelectorAll(
      ".variant-radio input:checked"
    );
    const values = Array.from(checkedRadios, (radio) => radio.value);
    this.options = Array.from(
      this.querySelectorAll(".variant-radio input:checked"),
      (input) => input.value
    );
    this.updateCurrentOptions();
  }
}

theme.finishedProductLoading = function() {
  const colorVariantBox = document.querySelector('.product-form__input[data-option="Color"] .variant-radios--wrapper')
  if(colorVariantBox) {
    colorVariantBox.classList.remove('loading');
  }
};

theme.getStyleAndType = function(title) {
  const prefix = title.split(window.splitValue)[0].trim().split(' ');
  const style = prefix[0];
  const type = prefix.slice(-1)[0]
  return `${style} ${type}`;
}

String.prototype.includes = function (...args) {  
  return args.filter(str => this.indexOf(str) > -1).length === args.length;
};


const reorderPenelopes = () => {
  const penelopeOrder = ['Tiger Lily','Sunrose','Bordeaux'];
  const wrapper = document.querySelector('.variant-radios--wrapper');
  penelopeOrder.forEach(color => {
    const colorEl = document.querySelector(`.variant-radio input[value="${color}"]`);
    if(!colorEl) return true;
    wrapper.appendChild(colorEl.parentNode);
    
  });
};

/* Set it all up */
window.initProductSwatches = function () {
  
  let isPenelope = false;
  const titleSplit = productJSON.title.split(window.splitValue);
  let saleProduct = productJSON.compare_at_price > productJSON.price;
  if(titleSplit.length <= 1 || productJSON.vendor === "Archive") {
    customElements.define("variant-selects", VariantSelects);
    customElements.define("variant-radios", VariantRadios);
    // console.log(productJSON.vendor);
    return false;
  }
  if(productJSON.title.indexOf('Penelope') > -1) {
    saleProduct = false;
  }

  const addButtons = document.querySelectorAll('.product-form__submit');
  if(addButtons){
    addButtons.forEach(function (addButton) {
      addButton.classList.add('loading');
      addButton.textContent = '';
    })
  }
  
  const productTitle = titleSplit[0].replace('x Devon Lee Carlson','').replace('x GIGI HADID','').replace('x BELLA HADID','').replace('x SYDNEY SWEENEY','').replace('x PAMELA ANDERSON','').replace('x GUIZIO','').replace('x DJERF AVENUE','').replace('x OREBELLA','').replace('x Réalisation Par','').replace('x Khy','').replace('x LEXXOLA','').replace('x JENNIE','').replace('x Paige Lorenze','').replace('x KHY','').trim();
  const productColor = titleSplit[1].trim();
  const productTitleSplitSpaces = productTitle.split(" ");
  const productStyleName = productTitleSplitSpaces[0];
  const productFabric = window.matchFabric ? `+${window.matchFabric}` : ''; 
  const productType = productTitleSplitSpaces.slice(-1)[0];
  const searchUrl = `/search?q=title:${productStyleName}${productFabric}+${productType}&type=product&view=api`;
  
  const results = [];
  results.push(productColor);
  const productVariantsJsonElement = document.querySelector(
    "#productVariantsJson"
  );
  const productVariantsJson = JSON.parse(productVariantsJsonElement.innerHTML);
  const colorSelect = document.querySelector(".select__select--color");
  const colorButton = document.querySelector(
    '.product-form__input[data-option="Color"] .variant-radios--wrapper'
  );
  let colorsFound = [];

  const colorDropdown = document.querySelector('.product__color-swatches-dropdown');

  productVariantsJson.forEach((v) => {
    v.productUrl = "/products/" + productJSON.handle;
  });

  fetch(searchUrl)
    .then((response) => response.text())
    .then((responseText) => {
      const items = JSON.parse(responseText);
	  let hasCore = false;
      let hasSecondary = false;
      items.forEach((item, i) => {
		let itemSale = item.compare_at_price > item.price;

        if(item.title.indexOf('Penelope') > -1) {
          itemSale = false;
          isPenelope = true;
        }
        if (item.title.indexOf("Extended") > -1) return true;
        if (item.vendor === "Archive") return true;
		if (saleProduct !== itemSale) return true;


		const itemTitle = item.title.replace('x Devon Lee Carlson','').replace('x GIGI HADID','').replace('x BELLA HADID','').replace('x SYDNEY SWEENEY','').replace('x PAMELA ANDERSON','').replace('x GUIZIO','').replace('x DJERF AVENUE','').replace('x OREBELLA','').replace('x Réalisation Par','').replace('x Khy','').replace('x LEXXOLA','').replace('x JENNIE','').replace('x Paige Lorenze','').replace('x KHY','').trim();
		const firstWord = itemTitle.split(' ')[0];
        // console.log(itemTitle,productStyleName,productType);
		if(itemTitle.indexOf(productStyleName) === -1) return;
		if(itemTitle.indexOf(productType) === -1) return;
		if(productStyleName != firstWord) return;
		if(window.matchFabric && item.tags.indexOf(window.matchFabric) === -1) return;


		// console.log(item);

		const ogStyleType = theme.getStyleAndType(productJSON.title.replace('x Devon Lee Carlson','').replace('x GIGI HADID','').replace('x BELLA HADID','').replace('x SYDNEY SWEENEY','').replace('x PAMELA ANDERSON','').replace('x GUIZIO','').replace('x DJERF AVENUE','').replace('x OREBELLA','').replace('x Réalisation Par','').replace('x Khy','').replace('x LEXXOLA','').replace('x JENNIE','').replace('x Paige Lorenze','').replace('x KHY',''));
		const newStyleType = theme.getStyleAndType(itemTitle);

        let color = item.title.split(window.splitValue)[1];

        const handle = theme.toHandle(color);
        if(theme.swatchColors.indexOf(handle) === -1) return;

        
        if (color) {
          color = color.trim();
        }
        if (colorsFound.indexOf(color) > -1) return;
        colorsFound.push(color);


        const itemVariants = item.variants;

        itemVariants.forEach((v) => {
          v.productUrl = "/products/" + item.handle;
        });

        const colorFieldset = document.querySelector(
          'fieldset[data-option="Color"]'
        );
        const checked = productColor === color ? "checked" : "";

        let isCore = item.tags.indexOf('2022') > -1;

		let hidden = isCore ? false : true;

        if (colorButton) {
          const swatch = document.createElement("div");
          swatch.classList.add("variant-radio");
// 		  if(hidden) {
// 			swatch.classList.add("hidden");
// 		  }
//        swatch.setAttribute('data-core-color',isCore);
		  swatch.innerHTML = `<input type="radio" ${checked} id="template-product__main-Color-${i + 1}" name="Color" value="${color}" data-color-handle="${handle}" data-url="/products/${item.handle}" data-title="${item.title}">
        <label class="mx-0 inline-block" data-tooltip="${color}" for="template-product__main-Color-${
            i + 1
          }" style="background-image:url('/cdn/shop/files/${color.toLowerCase().replace(/ /g,'-')}_50x.jpg');background-size:cover;background-position:center;"><span class="visually-hidden">${color}</span></label>`;

         colorButton.appendChild(swatch);

        }
        if (colorDropdown) {
          let swatchColor = document.createElement("a");
          swatchColor.classList.add("product__swatch");
          swatchColor.href = `/products/${item.handle}`;

          const currentHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
          if (item.handle === currentHandle) {
            swatchColor.classList.add("active");
          }

        
          const imageUrl = `/cdn/shop/files/${handle}.jpg`; // You can adjust the path/extension here
          const labelText = color;
        
          swatchColor.innerHTML = `
            <div class="product__swatch-color" data-value="${handle}" style="background-image: url('${imageUrl}');background-position:center;background-size:cover;"></div>
            <span class="caption-neue">${labelText}</span>
          `;
        
          colorDropdown.appendChild(swatchColor);

          if (typeof window.variantColorHandler === 'function') {
            window.variantColorHandler();
          }
        }


        if (colorSelect) {
          const option = document.createElement("option");
          option.value = color;
          option.textContent = color;
          colorSelect.appendChild(option);
        }

		if(window.productJSON.id != item.id) {
          productVariantsJson.push(...itemVariants);
          window.productJSON.variants.push(...itemVariants);
		}

        results.push(color);
      });

	  if(hasSecondary) {
        document.querySelector('.colors--secondary__wrapper').classList.remove('hidden');
      }

      if(isPenelope) {
        reorderPenelopes();
      }

      productVariantsJsonElement.textContent = JSON.stringify(productVariantsJson);
      customElements.define("variant-selects", VariantSelects);
      customElements.define("variant-radios", VariantRadios);
      
      if(!window.currentVariant) return;
    });
};

window.initProductSwatches();